$(document).ready(function () {
    $('#authorTabs .nav-link').on('click', function (e) {
        e.preventDefault();

        $('.nav-link').removeClass('active');
        $('.tab-pane').removeClass('show active');

        $(this).addClass('active');

        let target = $(this).attr('data-bs-target');
        $(target).addClass('show active');
    });

    $('#authorTabsContent .list-group-item').on('click', function (e) {
        e.preventDefault();

        const $this = $(this),
            url = $this.data('url');

        window.location.href = url;
    });
});



// WEBPACK FOOTER //
// ./js/modules/authorPage.js